//
// Module for the External Login Approval wizard's Link To Existing User Step Grid (partial)
//
rs.module("content/security/administration/externalloginapproval/linktoexistinguserstepgrid",

    ["controls/components/event-banner",
     "content/security/administration/externalloginapproval/linktoexistinguserstep"],

    function (eventBanner, linkToExistingUserStep) {

        // Initialize the module
        function initialize(grid, disableNextButton) {

            // set grid variable for access on dependent JS module (_linktoexistinguserstep.js)
            linkToExistingUserStep.setGrid(grid);

            // Get the wizard's next button and conditionally disable it when grid first displays 
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            wizardNextButton.setDisabled(disableNextButton);

            var _executeSelectionChanged;

            if (grid) {

                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want to react in that case.
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked.
                    if (_executeSelectionChanged && values.length > 0) {

                        // clear any messages in the message banner
                        eventBanner.removeAllMessages();

                        // Enable the wizard's next button                    
                        wizardNextButton.setDisabled(false);
                    }

                    _executeSelectionChanged = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);